import React, { useState, useRef, useContext } from "react";
import { Images } from "../../theme";
import "./styles.css";
import { AuthContext } from "../../context/AuthContext";
import { useTranslation } from "react-i18next";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import GoogleLogin from "react-google-login";
// import TwitterLogin from "react-twitter-login";

const Login = (props) => {
  const AuthData = useContext(AuthContext);
  const { google_login, facebook_login, twitter_login, isLoading } = AuthData
    ? AuthData
    : null;
  let { t } = useTranslation();
  const twitterRef = useRef(null);

  const handleTwitterClick = (twitterRef) => {
    twitterRef.current.handleLoginClick();
  };

  return (
    <div className="d-flex justify-content-center text-14 my-1">
      <GoogleLogin
        clientId="1049636028432-rb7dqt61rpqs6use3lv7p9plsuuhvck3.apps.googleusercontent.com"
        buttonText="Login"
        render={(renderProps) => (
          <div className="icon-container pointer" onClick={renderProps.onClick}>
            <img className="social-icon" src={Images.google_icon} alt="image" />
          </div>
        )}
        onSuccess={(e) => google_login(e, props)}
        onFailure={(e) => google_login(e, props)}
        cookiePolicy={"single_host_origin"}
      />

      <FacebookLogin
        appId="312670427622192"
        fields="name,email,picture"
        callback={facebook_login}
        render={(renderProps) => (
          <div className="icon-container pointer" onClick={renderProps.onClick}>
            <img
              className="social-icon"
              src={Images.facebook_icon}
              alt="image"
            />
          </div>
        )}
      />

      <div
        className="icon-container pointer"
        onClick={() => handleTwitterClick(twitterRef)}
      >
        {/* <TwitterLogin
          authCallback={twitter_login}
          className="google-ui"
          ref={twitterRef}
          consumerKey={"L8qq9PZyRg6ieKGEKhZolGC0vJWLw8iEJ88DRdyOg"}
          // consumerSecret={CONSUMER_SECRET}
        /> */}
        <img className="social-icon" src={Images.twitter_icon} alt="image" />
      </div>
    </div>
  );
};

export default Login;

// <script>
//   window.fbAsyncInit = function() {
//     FB.init({
//       appId      : '{your-app-id}',
//       cookie     : true,
//       xfbml      : true,
//       version    : '{api-version}'
//     });

//     FB.AppEvents.logPageView();

//   };

//   (function(d, s, id){
//      var js, fjs = d.getElementsByTagName(s)[0];
//      if (d.getElementById(id)) {return;}
//      js = d.createElement(s); js.id = id;
//      js.src = "https://connect.facebook.net/en_US/sdk.js";
//      fjs.parentNode.insertBefore(js, fjs);
//    }(document, 'script', 'facebook-jssdk'));
// </script>
